import React, { useEffect, useState, useRef } from "react";
import { ButtonGroup, Grid, FormControlLabel, Switch, Button } from "@material-ui/core";
import { RecordingButtons } from "../stream/RecordingButtons";
import { VideoTimer } from "../stream/VideoTimer";
import { useTranslation } from "react-i18next";
import UndoIcon from "@mui/icons-material/Undo";
import { useDataProvider } from "../../api/DataProvider";
import { pDataProvider, pDB_user_roles } from "../../utils/parameters";
import { Add, Remove, Send } from '@material-ui/icons';
import SpeedIcon from '@mui/icons-material/Speed';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import Paper from '@material-ui/core/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled';
import MonitorIcon from '@mui/icons-material/Monitor';
import Slider from '@material-ui/core/Slider';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import { useTimerProvider } from '../../api/TimerProvider'
import { useVideoSyncMonitor } from "../../api/VideoSyncMonitor";
import PreviewIcon from '@mui/icons-material/Preview';


export function RecorderReferenceVideo(props) {

    const {src_video, video_text, setCustomTimerRecorder, hideControls, isHideText, setIsHideText } = props
    const { t } = useTranslation("global")
    const { json_data_meaning, comm_getPublicURLVideoData } = useDataProvider();
    const { timer, timerActive } = useTimerProvider();

    // const [src_video, set_src_video] = useState(null);
    // const [text_video, set_text_video]  = useState("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ") 


    const [videoDuration, setVideoDuration] = useState(0);
    const currentVideoSpeedRef = useRef(1);
    const [currentVideoSpeed, setCurrentVideoSpeed] = useState(1);

    const videoReferenceRef = useRef(null);

    const [isLoop, setIsLoop] = useState(false)
    const [isHide, setIsHide] = useState(false)
    
    const [autoHide, setAutoHide] = useState(false)

    const {
        isPlayingReference,
        setIsPlayingReference,
        forceStartVideoReference,
        forceStopVideoReference,
        forceCurrentTimeVideoReference,
        isLoadedReference,
        setIsLoadedReference
    } = useVideoSyncMonitor();


    useEffect(() => {
        startVideo()
    }, [forceStartVideoReference])

    useEffect(() => {
        stopVideo()
    }, [forceStopVideoReference])


    useEffect(() => {
        videoReferenceRef.current.currentTime = forceCurrentTimeVideoReference
    }, [forceCurrentTimeVideoReference])


    useEffect(() => {
        setCurrentVideoSpeed(1)
        console.log("🚀 ~ RecorderReferenceVideo ~ timer:", timer)
        console.log("🚀 ~ RecorderReferenceVideo ~ timerActive:", timerActive)
        if (timerActive === 'Countdown'){
            console.log("🚀 ~ RecorderReferenceVideo ~ PAUSAR:", timer)
            console.log("🚀 ~ RecorderReferenceVideo ~ PONER A 0 TIEMPO DEL VIDEO:", timer)
            if (timer>0){
                if (autoHide){
                    setIsHide(true)
                }
                stopVideo()
            }else{
                startVideo()
            }
        }
        if (timerActive === 'Recording'){
            console.log("🚀 ~ RecorderReferenceVideo ~ PLAY:", timer)
            if (timer === 0){
                if (autoHide){
                    setIsHide(false)
                }
            }
           
        }
      }, [timer])
      
    
      useEffect(() => {
        console.log("🚀 ~ RecorderReferenceVideo ~ timerActive:", timerActive)
      }, [timerActive])

      useEffect(() => {
        setIsHideText(false)
      }, [src_video])


    // useEffect(() => {
    //     const keys = Object.keys(json_data_meaning);
    //     const randomDefinitionKey = keys[Math.floor(Math.random() * keys.length)];
    //     set_src_video(comm_getPublicURLVideoData(pDataProvider.dir_vid_definition, randomDefinitionKey));
    //     setIsHideText(false)
    // }, []);

    function formatDuration(duration) {
        try{
            const minutes = Math.floor(duration / 60);
            const seconds = Math.floor(duration % 60);
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        } catch {
            return ''
        }

    }

    useEffect(() => {
        if (videoReferenceRef.current) {
            videoReferenceRef.current.onloadedmetadata = () => {
                setVideoDuration(videoReferenceRef.current.duration);
            };
        }
    }, [src_video]);

    useEffect(() => {
        let videoDuration = videoReferenceRef.current.duration
        videoDuration = (videoDuration + 1 + (0.1 * videoDuration))
        let videoDurationRounded = Math.ceil(videoDuration)
        console.log("🚀 ~ startRecordingTimer ~ videoReferenceRef.current.duration:", videoReferenceRef.current.duration)
        console.log("🚀 ~ startRecordingTimer ~ videoDuration:", videoDuration)
        console.log("🚀 ~ startRecordingTimer ~ videoDurationRounded:", videoDurationRounded)

        setCustomTimerRecorder({
            'max':  videoDurationRounded + 2,
            'min':  videoDurationRounded -2,
            'step':  1,
            'timer': videoDurationRounded
        })
    }, [videoDuration]);


    useEffect(() => {
        if (videoReferenceRef.current) {
            currentVideoSpeedRef.current = currentVideoSpeed;
            videoReferenceRef.current.playbackRate = currentVideoSpeed;
            setVideoDuration(videoReferenceRef.current.duration / currentVideoSpeed);
            videoReferenceRef.current.play()
        }
        console.log("🚀 ~ RecorderReferenceVideo ~ currentVideoSpeed:", currentVideoSpeed)
    }, [currentVideoSpeed]);

    const stopVideo = () => {
        console.log("🚀 ~ VIDEOSSSS ~ stopVideo:", stopVideo)
        if (videoReferenceRef.current) {
            videoReferenceRef.current.pause(); // This will pause the video
            videoReferenceRef.current.currentTime = 0; // This will rewind the video to the start
        }
    }

    const startVideo = () => {
        console.log("🚀 ~ VIDEOSSSS ~ startVideo:", startVideo)
        if (videoReferenceRef.current) {
            videoReferenceRef.current.play(); // This will pause the video
            videoReferenceRef.current.currentTime = 0; // This will rewind the video to the start
        }
    }

    const handlePlayButton = () => {
        if (videoReferenceRef.current) {
            if (isPlayingReference){
                stopVideo()
            }else{
                startVideo()
            }
        } 
    }

    useEffect(() => {
        console.log("🚀 ~ RecorderReferenceVideo ~ isPlayingReference:", isPlayingReference)
    }, [isPlayingReference])

  
    return (
  
      <>
      {isHide ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '5px' }}>
            <Button 
              color="primary" 
              style={{
                height: '500px', 
                maxWidth: '30px', 
                border: '2px solid #5ea0d4', 
                borderRadius: '10px', 
                margin: 'auto'
              }} 
              onClick={() => setIsHide(false)}
            >
              <PreviewIcon fontSize='large'/>
            </Button>
          </div>
        ) : (
            <>
            <Grid container className={`sig_Home_MainSectionContainer`}>
                <Grid item>
                    <Grid container className="sig_Home_MainSectionOptions">
                        <div>
                        <Grid container className='sig_Home_ButtonsContainerInner' style={{marginTop: '15px', visibility: hideControls ? "hidden" : "visible" }}>

                                    <Grid item>
                                    <ButtonGroup className='sig_Home_TimerButtons' variant="contained" color="primary">
                                        <Button style={{backgroundColor: isPlayingReference ? '#f55050fc': '', color: isPlayingReference ? 'white': ''}} onClick={handlePlayButton}> {isPlayingReference ? 'Detener': 'Reproducir'} </Button>
                                        <Button style={{backgroundColor: isHideText ? 'red': 'green', color: 'white'}} onClick={()=>{setIsHideText(!isHideText)}}> {isHideText ? "Ocultar" : "Ver texto"} </Button>
                                    </ButtonGroup>
                                    </Grid>

                                    <Grid item>
                                        <ButtonGroup className='sig_Home_TimerButtons' variant="contained" color="primary">
                                            <Button startIcon={<Remove />} onClick={()=>{setCurrentVideoSpeed(currentVideoSpeed - 0.1)}}></Button>
                                            <Button startIcon={<SpeedIcon />} onClick={()=>{setCurrentVideoSpeed(1)}} > { currentVideoSpeed.toFixed(1) } </Button>
                                            <Button startIcon={<Add />} onClick={()=>{setCurrentVideoSpeed(currentVideoSpeed + 0.1)}}></Button>
                                        </ButtonGroup>
                                    </Grid>

                                    <Grid item>
                                    <ButtonGroup className='sig_Home_TimerButtons' variant="contained" color="primary">
                                        <Button style={{width: '100px'}} onClick={()=>{setIsHide(true)}}> OCULTAR </Button>
                                        <Button style={{backgroundColor: autoHide ? '#9efd6f': ''}} onClick={()=>{setAutoHide(!autoHide)}}> AUTO </Button>
                                    </ButtonGroup>
                                    </Grid>
                                </Grid >

                            <video ref={videoReferenceRef}
                                // controls 
                                style={{ width: '600px', height: '600px'}} 
                                autoPlay 
                                loop={isLoop}
                                src={src_video}
                                muted
                                onPlaying={()=> { setIsPlayingReference(true); setIsLoadedReference(true) } }
                                onEnded={() => setIsPlayingReference(false)}
                                onPause={() => setIsPlayingReference(false)}
                                // onTimeUpdate={() => setVideoReferenceMonitorCurrentTime(videoReferenceRef.current.currentTime)}
                                />
                            { isHideText &&
                            <Grid item style={{width: '600px'}}>
                                    <div className='sig_SignModal_PaperInfo' style={{backgroundColor: 'white',maxWidth: '90%', margin: '8px auto', padding: '10px', borderRadius: '4px', minHeight: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #5ea0d4'}}>
                                        <span style={{fontSize: '17px'}}> {video_text} </span>
                                    </div> 
                            </Grid>
                            }

                        </div>
                    </Grid>
                </Grid>
            </Grid>
            </>
            
        )}
        
      </>  
              
              
      );
    }